import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from 'gatsby-image';
import * as Markdown from 'react-markdown';
import { customColor } from "../../lib/helpers";
import { ButtonArrowRight } from "../Button";
import style from "./Content.module.css";

const TwoColumnContent = ({ title, copy, textAlign, displayWidth, gridLayout, sectionColor, slug }) => {

  useEffect(
    () => {
      const hrefs = document.getElementsByTagName('A');
      for (let val of Object.values(hrefs)) {
        if (val.getAttribute('title')) {
          val.classList.add("uk-button", "uk-button-large", "uk-button-text", "rightArrow")
        } else {
          val.setAttribute('target', '_blank')
        }
      }

    }, []
  )

  const sectionImage = useStaticQuery(graphql`
        query sectionImage {
          allContentfulSectionItem {
            edges {
              node {
                slug
                copy {
                    childMarkdownRemark {
                        html
                    }
                }
                code {
                    childMarkdownRemark {
                        html
                    }
                }
                image {
                    title
                    file {
                      url
                      fileName
                    }
                  localFile {
                    publicURL
                    childImageSharp {
                      fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `);

  const entry = sectionImage.allContentfulSectionItem.edges.find(d => d.node.slug === slug).node
  let backgroundColor = customColor(sectionColor)
  backgroundColor = backgroundColor !== "None" ? backgroundColor : null

  return (
    displayWidth === "expand" ?
      <div className="content__twoColumnContent uk-grid uk-grid-collapse uk-grid-match">
        <div className={`uk-width-expand uk-height-min-medium ${textAlign ? "uk-flex-last@m" : "uk-flex-first"}`}>
          <Img
            style={{ height: "100%" }}
            fluid={entry.image.localFile.childImageSharp.fluid}
            alt={title}
            objectFit="cover"
            objectPosition="50% 50%" />
        </div>
        <div className={`${gridLayout ? "uk-width-" + gridLayout + "@m" : "uk-width-1-2@m"} ${backgroundColor ? `uk-background ${backgroundColor}` : ""} ${backgroundColor ? "uk-light" : null} uk-height-min-large uk-flex uk-flex-middle uk-flex-center ${textAlign && textAlign && "uk-flex-first@m"}`}>
          <div className="uk-width-5-6 uk-width-4-5@s uk-width-3-5@m">
            <h2 className="h2__large">{title}</h2>
            <div className="uk-text-xlarge">
              <Markdown
                source={copy}
                escapeHtml={false}
              />
            </div>
          </div>
        </div>
      </div>
      :
      <section id={slug} className={`${style.twoColumnContent} content__twoColumnContent ${backgroundColor ? backgroundColor : ""}`}>
        <div className={`uk-container uk-padding-remove uk-container-${displayWidth}`}>
          <div className="">
            <div id={slug}>

              <div className="uk-grid uk-grid-collapse uk-height-min-large">
                <div className={`uk-width-expand ${textAlign && !textAlign ? "uk-flex-right" : "uk-flex-left"}`}>
                  {entry.code && entry.code.childMarkdownRemark ?
                    <div className="uk-flex uk-flex-column uk-flex-center uk-flex-middle">
                      <div className="uk-margin-small-bottom">
                        <Markdown
                          source={entry.code.childMarkdownRemark.html}
                          escapeHtml={false}
                        />
                      </div>
                    </div>
                    :
                    entry.image.localFile.childImageSharp ?
                      <Img
                        fluid={entry.image.localFile.childImageSharp.fluid}
                        alt={title}
                        className={`${style.twoColumnContentMedia} uk-height-1-1`}

                      />
                      : entry.image?.file?.contentType?.split('/')[0] === "image" ?
                        <img
                          alt={title}
                          src={entry.image.localFile.publicURL}
                          data-uk-img />
                        :
                        <video
                          style={{ maxHeight: "400px" }}
                          className={`uk-video uk-box-shadow-small uk-margin-auto-left uk-margin-small-right`}
                          muted controls="1" data-uk-video>
                          <source src={entry.image.file.url} type="video/mp4" />
                        </video>
                  }
                </div>
                <div className={`${gridLayout ? "uk-width-" + gridLayout + "@m" : "uk-width-1-2@m"} uk-height-min-large uk-flex uk-flex-middle uk-flex-center ${textAlign && textAlign && "uk-flex-first@m"} ${backgroundColor ? "uk-light" : null}`}>
                  <div className="uk-width-1-1 uk-width-4-5@s uk-width-2-3@m">
                    <h2 className="h2__large">{title}</h2>
                    <div className="uk-text-xlarge">
                      <Markdown
                        source={copy}
                        escapeHtml={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
}

export default TwoColumnContent;
